import { useMutation, useQuery } from '@tanstack/react-query';

import { mailerOrdersAPI } from '../api/mailer-orders';

/**
 * Fetch all past mailer orders for the authenticated user
 */
export function useMailerOrders() {
  return useQuery({
    queryKey: ['mailer-orders'],
    queryFn: mailerOrdersAPI.getOrders,
  });
}

/**
 * Get a pricing preview based on recipients and donation amount
 * Only fetches if payload is complete and valid
 */
export function useMailerPreview(payload) {
  return useQuery({
    queryKey: ['mailer-preview', payload],
    queryFn: () => mailerOrdersAPI.preview(payload),
    enabled: Boolean(payload?.electionId && payload?.recipients?.length > 0),
  });
}

/**
 * Submit a mailer order and redirect to Stripe Checkout
 */
export function useCreateMailerOrder() {
  const mutation = useMutation({
    mutationFn: mailerOrdersAPI.create,
    onSuccess: ({ data }) => {
      window.location.href = data.checkoutUrl;
    },
  });

  return {
    createOrder: mutation.mutate,
    isLoading: mutation.isPending,
    error: mutation.error,
  };
}
